import React from 'react';
import { useWallet } from '../hooks/useWallet';
import TransactionHistory from '../components/TransactionHistory';


export default function TransactionsPage() {
  const { wallet } = useWallet();

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">Wallet Transactions</h1>
        <p className="mt-1 text-sm text-gray-500">
          Send and receive tokens, and view your transaction history
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-1">
          <div className="sticky top-6">
            <div className="bg-white rounded-lg shadow p-6 mb-6">
              <h2 className="text-lg font-semibold mb-4">Wallet Balance</h2>
              {wallet ? (
                <div className="space-y-4">
                  <div>
                    <div className="flex justify-between items-center">
                      <span className="text-gray-500">SOL</span>
                      <span className="font-medium">0.00</span>
                    </div>
                    <div className="h-2 bg-gray-100 rounded-full mt-1 overflow-hidden">
                      <div className="h-full bg-blue-500 rounded-full" style={{ width: '100%' }}></div>
                    </div>
                  </div>
                  <div>
                    <div className="flex justify-between items-center">
                      <span className="text-gray-500">USDC</span>
                      <span className="font-medium">0.00</span>
                    </div>
                    <div className="h-2 bg-gray-100 rounded-full mt-1 overflow-hidden">
                      <div className="h-full bg-green-500 rounded-full" style={{ width: '75%' }}></div>
                    </div>
                  </div>
                  <div>
                    <div className="flex justify-between items-center">
                      <span className="text-gray-500">USDT</span>
                      <span className="font-medium">0.00</span>
                    </div>
                    <div className="h-2 bg-gray-100 rounded-full mt-1 overflow-hidden">
                      <div className="h-full bg-purple-500 rounded-full" style={{ width: '50%' }}></div>
                    </div>
                  </div>
                </div>
              ) : (
                <p className="text-gray-500">Connect your wallet to view balances</p>
              )}
            </div>

          </div>
        </div>

        <div className="lg:col-span-2">
          <TransactionHistory />
        </div>
      </div>
    </div>
  );
}
